<template>
  <div class="form">
    <div v-show="!loading">
      <h1>{{ $lang("大眾單車遊") }}</h1>
      <b-form ref="form1" @submit="onSubmit">
        <div class="form-header">
          <div class="checkbox-group">
            <b-form-checkbox v-model="form.isAgree2" :disabled="is_perview">
              <span style="padding-top: 2px" class="lbl">{{
                $lang(
                  "我已知悉於活動當天需出示提前至少14天完成接種兩劑新型冠狀病毒疫苗或7日核酸檢測陰性的證明"
                )
              }}</span>
            </b-form-checkbox>
            <b-form-checkbox
              v-if="isAdultnewTeamShow == 1"
              v-model="form.isAgree1"
              :disabled="is_perview"
            >
              <span class="lbl"> {{ $lang("TEXT_ACCEPT_SELF_6") }}</span>
            </b-form-checkbox>
            <template v-if="isAdultnewTeamShow == 2">
              <p>
                <span
                  >{{ $lang("或上傳所有參加者的健康聲明書") }}(<a
                    :href="url"
                    target="_blank"
                    >{{ $lang("TITLE_HEALTH_DOWN_URL") }}</a
                  >){{ $lang("ATTENTION_FOUR_LAST") }}</span
                >
              </p>
              <div class="upload-check" :disabled="is_perview">
                <InputFile
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="form.healthFile"
                  :word="$lang('BTN_UPLOAD_FILE')"
                  :disabled="is_perview"
                />
                <span>*{{ $lang("TEXT_ACCEPT_SELF_4") }}</span>
              </div>
            </template>
          </div>
        </div>

        <template v-for="item in form.teamMembers">
          <public-form
            @isAdultNewTeam="isAdultNewTeam"
            :participateDate="participateDate"
            :requiredType="requiredType"
            :key="item.key"
            :value.sync="item"
            :rules="rules"
            class="dashed"
            ref="form-item"
            :disabled="is_perview"
          >
            <template v-if="form.teamMembers.length > 1" v-slot:remove>
              <b-form-group horizontal>
                <label slot="label"></label>
                <b-btn
                  variant="info"
                  size="sm"
                  class="del"
                  @click.prevent="handleRemove(item)"
                  ><i class="fa fa-trash-o" style="margin-right: 5px"></i
                  >{{ $lang("刪除") }}</b-btn
                >
              </b-form-group>
            </template>
          </public-form>
        </template>
        <div class="form-footer">
          <div>
            <template v-if="!is_perview">
              <b-btn
                v-if="form.teamMembers.length < 4"
                variant="success btn-round"
                @click.prevent="handleAdd"
                >+{{ $lang("添加參賽者") }}</b-btn
              >
              <button
                type="submit"
                class="btn btn-primary btn-submit save"
                @click="save"
                :disabled="isDisable"
              >
                {{ $lang("TEXT_SAVE") }}
              </button>
              <button
                type="submit"
                class="btn btn-primary btn-submit save"
                @click="submitForm"
                :disabled="isDisable"
              >
                {{ $lang("提交") }}
              </button>
            </template>
            <p v-html="$lang('TITLE_FORM_TIP')">
              <!-- {{  }} -->
            </p>
          </div>
        </div>
      </b-form>
    </div>
    <div class="spinner" v-show="loading">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
  </div>
</template>

<script>
import { $apis } from "@/helper";
// import SummerForm from "@/components/SummerForm";
import PublicForm from "@/components/PublicForm";
import InputFile from "@/components/InputFile";
import { ValidationObserver } from "vee-validate";
import utils from "@/helper/utils";

export default {
  props: {
    mode: {
      type: String,
      default: "new",
    },
  },
  components: {
    InputFile,
    PublicForm,
    ValidationObserver,
  },
  data() {
    return {
      isAdultnew: false,
      isAdultnewTeam: false,
      isAdultnewTeamShow: 1,
      loading: false,
      index: 4,
      requiredType: false,
      status: "",
      isDisable: false,
      // selected: "individual",
      isIdentity: true,
      participateDate: [],
      rules: {
        birth: {
          cycling_conforming_age: [1952, 2010],
        },
        // phone: {
        //     mobile: ''
        // }
      },
      rules_adult: {
        birth: {
          team_conforming_age: [1965, 2004],
        },
      },
      form: {
        isAgree2: false,
        id: null,
        healthFile: "",
        isAgree1: false,
        teamMembers: [
          {
            tShirtSize: "",
            firstVaccination: "",
            secondVaccination: "",
            name: "",
            bornAt: "",
            gender: "M",
            phone: "",
            idNumber: "",
            participateDate: [],
            // isNeedCar: "",
          },
        ],
      },
    };
  },
  watch: {
    isAdultnewTeam(n) {
      // console.log(typeof n,typeof n=='string',n);
      var a = this.form.teamMembers.every((el) => el.bornAt != "");
      var d = this.form.teamMembers.every((el) => typeof el.bornAt == "object");
      console.log(a, b);
      if (a && d) {
        var b = this.form.teamMembers.every(
          (el) => el.bornAt.getFullYear() <= 2004
        );
        var c = this.form.teamMembers.every(
          (el) => el.bornAt.getFullYear() > 2004
        );
        if (b) {
          //全是成人
          this.isAdultnewTeamShow = 1;
        } else if (c) {
          //全是未成年
          this.isAdultnewTeamShow = 2;
        } else {
          //都有
          this.isAdultnewTeamShow = 2;
        }
      } else {
        var a = this.form.teamMembers.every((el) => el.bornAt != "");
        if (a) {
          let ad = 0;
          let noad = 0;
          this.form.teamMembers.map((el) => {
            if (typeof el.bornAt == "string") {
              if (el.bornAt != "") {
                console.log(el.bornAt, "dates");
                if (Number(el.bornAt.substring(0, 4)) <= 2004) {
                  ad = ad + 1;
                  console.log(1);
                } else {
                  noad += 1;
                }
              }
            } else {
              if (el.bornAt != "") {
                console.log(el.bornAt.getFullYear(), "date");
                if (el.bornAt.getFullYear() <= 2004) {
                  ad = ad + 1;
                } else {
                  noad += 1;
                }
              }
            }
          });
          if (ad == 0) {
            this.isAdultnewTeamShow = 2;
          } else if (noad == 0) {
            this.isAdultnewTeamShow = 1;
          } else {
            this.isAdultnewTeamShow = 2;
          }
        }
      }
    },
    isAdultnew(n) {
      // this.form.healthFile = null;
      // this.form.isAgree1 = null;
    },
  },
  methods: {
    getGrouping(flag) {
      if (flag) {
        this.ispersion = false;
      } else {
        this.ispersion = true;
      }
    },
    getGroupings(flag) {
      if (flag) {
        this.ispersion = false;
      } else {
        this.ispersion = true;
      }
    },
    isAdultNewTeam(flag) {
      this.isAdultnewTeam = flag;
    },
    isAdultNew(flag) {
      if (flag) {
        this.isAdultnew = true;
      } else {
        this.isAdultnew = false;
      }
    },
    save() {
      this.requiredType = false;
      this.status = "draft";
      // console.log(this.form2.mixedChallenge.length);
    },
    submitForm() {
      this.requiredType = true;
      this.status = "approval";
    },
    async onSubmit(evt) {
      evt.preventDefault();
      var form = {
        ...this.form,
        status: this.status,
        teamMembers: this.uploadMembers(this.form.teamMembers),
      };
      if (this.status === "draft") {
        this.recordUpdate(form);
        this.errorScoll();
      } else {
        var haveChild = this.haveChild(form);
        if (haveChild) {
          var haveAdult = this.haveAdult(form);
          if (!haveAdult) {
            this.notification.error(
              this.$lang("報名者為2008-2010年出生的需有至少一位成年人陪同")
            );
            return false;
          }
        }
        var promise_list = await this.$refs["form-item"].map((item) =>
          item.onSubmit()
        );
        // var result = promise_list.every(item => item);
        // await this.$validator.validateAll("form1");
        // this.errorScoll();
        this.$validator.validateAll("form1").then((validate) => {
          Promise.all(promise_list).then((list) => {
            var result = list.every((item) => item);
            this.errorScoll();

            // if (form.isAgree2 && form.healthFile) {
            //   if (result) {
            //     this.recordUpdate(form);
            //     this.errorScoll();
            //   }
            // } else {
            //   this.notification.warning(this.$lang("TEXT_WARNING_1"));
            // }
            if (
              this.isAdultnewTeamShow == 1
                ? form.isAgree1 && form.isAgree2
                : form.isAgree2 && form.healthFile
            ) {
              if (result) {
                this.recordUpdate(form);
                this.errorScoll();
              }
            } else {
              this.notification.error(this.$lang("TEXT_WARNING_2"));
            }
          });
        });
      }
    },
    // 防止連續點擊重複提交
    PreventDuplicateSubmit() {
      this.isDisable = true;
      setTimeout(() => {
        this.isDisable = false; //点击一次时隔两秒后才能再次点击
      }, 2000);
    },
    errorScoll() {
      let errEle = document.querySelector(".is-invalid");
      errEle ? this.animateScroll(errEle, 50) : "";
    },
    animateScroll(element, speed) {
      //获取元素相对窗口的top值，此处应加上窗口本身的偏移
      let top = window.pageYOffset + element.getBoundingClientRect().top;
      // 获取当前距离窗口的top值
      let osTop = document.documentElement.scrollTop || document.body.srcollTop;
      let requestId;
      let currentNumber = 0;
      //采用requestAnimationFrame，平滑动画
      function step() {
        if (osTop >= top) {
          currentNumber = osTop -= speed;
          window.scrollTo(0, osTop);
          requestId = window.requestAnimationFrame(step);
        } else {
          window.cancelAnimationFrame(requestId);
        }
      }
      window.requestAnimationFrame(step);
    },
    haveChild(form) {
      let haveChild = false;
      let teamMembers = form.teamMembers;
      teamMembers.forEach((item, index) => {
        const bornAt = item.bornAt;
        const year = utils.getYear(bornAt);
        if (year > 2008 && year <= 2010) {
          haveChild = true;
        }
      });
      return haveChild;
    },
    haveAdult(form) {
      let haveAdult = false;
      let teamMembers = form.teamMembers;
      teamMembers.forEach((item, index) => {
        const bornAt = item.bornAt;
        const year = utils.getYear(bornAt);
        if (year <= 2004 && year >= 1952) {
          haveAdult = true;
        }
      });
      return haveAdult;
    },
    handleRemove(item) {
      if (this.form.teamMembers.length <= 1) {
        return;
      }
      var index = this.form.teamMembers.indexOf(item);
      if (index !== -1) {
        this.form.teamMembers.splice(index, 1);
      }
    },
    handleAdd() {
      this.index++;
      this.form.teamMembers.push({
        tShirtSize: "",
        firstVaccination: "",
        secondVaccination: "",
        index: this.index,
        name: null,
        gender: null,
        bornAt: "",
        phone: "",
        idNumber: "",
        participateDate: [],
        // isNeedCar: Boolean,
      });
    },
    uploadMembers(list) {
      return list.map((item, index) => {
        delete item["key"];
        delete item["index"];
        item.participateDate = [this.participateDate[0].value];
        item.bornAt = this.$getYear(item.bornAt) || "";
        if (item.firstVaccination) {
          item.firstVaccination = this.$changeTime(item.firstVaccination) || "";
        }
        if (item.secondVaccination) {
          item.secondVaccination =
            this.$changeTime(item.secondVaccination) || "";
        }
        return item;
      });
    },
    recordUpdate(form) {
      if (this.status == "draft") {
        this.saveForm(form)
          .then((resp) => {
            let type = this.mode;
            if (type == "edit") {
              this.notification.success(this.$lang("TITLE_CHANGE_SUCCESS"));
            } else {
              this.notification.success(this.$lang("TITLE_SAVE_SUCCESS"));
            }
            this.$router.push({
              name: "public-challenge",
            });
          })
          .catch((err) => {
            if (err.data.teamMembers instanceof Array) {
              err.data.teamMembers.forEach((item, index) => {
                this.$refs["form-item"][index].validateErrors(
                  item.path,
                  this.$lang(item.message)
                );
                this.notification.error(this.$lang(item.message));
              });
            } else {
              if (err.data.length == 0) {
                this.notification.error(this.$lang(err.message));
              } else {
                var errs = err.data.teamMembers;
                var that = this;
                Object.keys(errs).forEach(function(key) {
                  that.notification.error(that.$lang(errs[key].message));
                });
              }
            }
          })
          .finally(() => {
            this.errorScoll();
          });
      } else {
        this.recordPro(form)
          .then((resp) => {
            // let type = this.mode;
            // if (type == "edit") {
            //     this.notification.success(this.$lang("提交成功"));
            // } else {
            //     this.notification.success(this.$lang("提交成功"));
            // }
            this.notification.success(this.$lang("提交成功"));
            this.$router.push({
              name: "public-challenge",
            });
          })
          .catch((err) => {
            if (err.data.teamMembers instanceof Array) {
              err.data.teamMembers.forEach((item, index) => {
                this.$refs["form-item"][index].validateErrors(
                  item.path,
                  this.$lang(item.message)
                );
                this.notification.error(this.$lang(item.message));
              });
            } else {
              if (err.data.length == 0) {
                this.notification.error(this.$lang(err.message));
              }else
              {
                var teamMembers = err.data.teamMembers;
                var that = this;
                Object.keys(teamMembers).forEach(function(key) {
                  that.$refs["form-item"][key].validateErrors(
                    teamMembers[key].path,
                    that.$lang(teamMembers[key].message)
                  );
                  that.notification.error(that.$lang(teamMembers[key].message));
                });
              }
            }
          })
          .finally(() => {
            this.errorScoll();
          });
      }
    },
    recordUpdate2(form) {
      if (this.status == "draft") {
        this.saveForm(form)
          .then((resp) => {
            let type = this.mode;
            if (type == "edit") {
              this.notification.success(this.$lang("TITLE_CHANGE_SUCCESS"));
            } else {
              this.notification.success(this.$lang("TITLE_SAVE_SUCCESS"));
            }
            this.$router.push({
              name: "public-challenge",
            });
          })
          .catch((err) => {
            if (err.data.teamMembers instanceof Array) {
              err.data.teamMembers.forEach((item, index) => {
                this.$refs["form2-item"].validateErrors(
                  item.path,
                  this.$lang(item.message)
                );
                this.notification.error(this.$lang(item.message));
              });
            } else {
              var errs = err.data;
              this.notification.error(this.$lang(err.message));
            }
          });
      } else {
        this.recordPro(form)
          .then((resp) => {
            // let type = this.mode;
            // if (type == "edit") {
            //     this.notification.success(this.$lang("TITLE_CHANGE_SUCCESS"));
            // } else {
            //     this.notification.success(this.$lang("新增成功"));
            // }
            this.notification.success(this.$lang("提交成功"));
            this.$router.push({
              name: "public-challenge",
            });
          })
          .catch((err) => {
            if (err.data.teamMembers instanceof Array) {
              err.data.teamMembers.forEach((item, index) => {
                this.$refs["form2-item"].validateErrors(
                  item.path,
                  this.$lang(item.message)
                );
                this.notification.error(this.$lang(item.message));
              });
            } else {
              var errs = err.data;
              this.notification.error(this.$lang(errs.groupType.message));
            }
          });
      }
    },
    async recordPro(form) {
      this.PreventDuplicateSubmit();
      return new Promise((resolve, reject) => {
        $apis.public.recordUpdate(form)
          .then((resp) => {
            if (resp.code === 0) {
              resolve(resp);
            } else {
              reject(resp);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // save
    async saveForm(form) {
      this.PreventDuplicateSubmit();
      return new Promise((resolve, reject) => {
        $apis.public
          .save(form)
          .then((resp) => {
            if (resp.code === 0) {
              resolve(resp);
            } else {
              reject(resp);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    async recordDetail(id) {
      if (this.mode === "perview") {
        this.loading = true;
        let resp = await $apis.public.recordDetail({
          id,
        });
        this.loading = false;
        this.form = resp.data;
      } else {
        this.loading = true;
        let resp = await $apis.public.load({ id });
        this.loading = false;
        this.form = resp.data;
      }
    },
    getUserInfo() {
      this.loading = true;
      $apis.user
        .getUserInfo()
        .then((resp) => {
          var data = resp.data;
          (this.form.teamMembers[0].name =
            data.firstNameZh + data.lastNameZh ||
            data.FirstnamePt + data.LastnamePt),
            (this.form.teamMembers[0].bornAt = data.bornAt);
          this.form.teamMembers[0].gender = data.gender;
          this.form.teamMembers[0].idNumber = data.idNumber.slice(-4);
          this.form.teamMembers[0].phone = "";
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectedChange() {
      this.$validator.reset();
    },
    // 處理perview時混合體能挑戰賽的顯示與隱藏
    handelShow() {
      if (this.form2.isChild == false) {
        this.form2.public = this.form2.mixedChallenge;
      } else {
        this.form2.teenager = this.form2.mixedChallenge;
      }
    },
    // 獲取參數日期
    recordList() {
      $apis.public
        .recordList()
        .then((resp) => {
          this.participateDate = resp.data.participateDate;
          this.rules.cycling_conforming_age = [
            resp.data.ageRange[0],
            resp.data.ageRange[1],
          ];
          console.log(this.rules.cycling_conforming_age);
          // for(var i = 0; i < resp.data.participateDate.length; i++) {
          //     this.participateDate.push({ html: resp.data.participateDate[i].html, value: resp.data.participateDate[i].value, disabled: !resp.data.participateDate[i].isCanSignUp });
          // }
        })
        .catch((err) => {});
    },
    // 獲取參數日期
  },
  computed: {
    disabled() {
      return this.mode === "perview" || this.mode === "edit";
    },
    is_perview() {
      return this.mode === "perview";
    },
    is_edit() {
      return this.mode === "edit";
    },
    is_new() {
      return this.mode === "new";
    },
    downPdf() {
      return this.$store.getters["base/cyclingNewYearHealthFileExample"];
    },
    link() {
      return this.$store.getters["base/baseUrl"];
    },
    url() {
      return this.link + this.downPdf;
    },
  },
  created() {
    var id = this.$route.params.slug;
    var isNew = this.is_new;
    this.form.id = id;
    id && this.recordDetail(id);
    isNew && this.getUserInfo();
    this.recordList();
  },
};
</script>
